import React from "react";
import styles from "./bubble.module.css";

const HoverText = () => {
  return (
    <div className=" bg-black">
      <BubbleText />
    </div>
  );
};

const BubbleText = () => {
  return (

    <div className="">

      <h2 className="text-center font-lexend text-3xl md:text-5xl font-light bg-gradient-to-r from-[#F101FF] to-[#FF008A] bg-clip-text text-transparent">
        {"What is CSI Chapter VIT - AP".split("").map((child, idx) => (
          <span className={styles.hoverText} key={idx}>
            {child}
          </span>
        ))}
      </h2>

    </div>
  );
};

export default HoverText;